import { ProjectService } from "../ProjectService/project.service"
import { ProjectDelegate } from "../ProjectService/project.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { EmployeeService } from "../EmployeeService/employee.service";
export class ProjectServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService, employeeService?: EmployeeService
    ): ProjectService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new ProjectDelegate(config, httpProvider);

        return new ProjectService(delegate, authenticationService, employeeService);
    }
}